import React, { useEffect, useRef, useState } from 'react';
import { Protected } from '@components/layout/Protected';
import { Loading } from "@components/common/Loading";
import { Alert, Backdrop, Box, Breadcrumbs, Button, CircularProgress, Container, Divider, Grid, IconButton, Menu, MenuItem, Snackbar, Typography } from "@mui/material";
import { TableDataV2 } from '@/components/common/Tablev2';
import { WorkerService } from '@/service/services/Worker.service';
import { emphasize, styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import GroupsIcon from '@mui/icons-material/Groups';
import { AssistanceService } from '@/service/services/Assistance.service';
import { ModalDelay } from '@/components/Modal/ModalDelay';
import { ModalDelayDelete } from '@/components/Modal/ModalDelayDelete';
import { Props } from './Movements.type';
import { MovementsService } from '@/service/services/Movements.service';
import { ModalMovements } from '@/components/Modal/ModalMovements';
import { ModalMovementDelete } from '@/components/Modal/ModalMovementDelete';

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
    const backgroundColor =
        theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[800];
    return {
        backgroundColor,
        height: theme.spacing(3),
        color: theme.palette.text.primary,
        fontWeight: theme.typography.fontWeightRegular,
        '&:hover, &:focus': {
            backgroundColor: emphasize(backgroundColor, 0.06),
        },
        '&:active': {
            boxShadow: theme.shadows[1],
            backgroundColor: emphasize(backgroundColor, 0.12),
        },
    };
});

export const MovementsView: React.FC<Props> = (props:any): JSX.Element => {

    const [loading, setLoading] = useState<boolean>(false);
    const [workers, setWorkers] = useState<any>([]);
    const [workerSelected, setWorkerSelected] = useState<any>('');
    const [movements, setMovements] = useState<any>([]);
    const [showMovementsModal, setShowMovementsModal] = useState<boolean>(false);
    const [showMovementsDeleteModal, setShowMovementsDeleteModal] = useState<boolean>(false);
    const [movemntSelected, setMovemntSelected] = useState<any>('');
    const [actionSelected, setActionSelected] = useState<any>('');
    const [view, setView] = useState<String>('workers');
    const [showMovemnts, setShowMovements] = useState<boolean>(false);

    const cabecera = [
        { name: 'n_document', label: 'RUT TRABAJADOR' },
        { name: 'surname', label: 'APELLIDO PATERNO' },
        { name: 'second_surname', label: 'APELLIDO MATERNO' },
        { name: 'name', label: 'NOMBRES' }];

    const cabeceraMovements = [
        { name: 'movstaffdetail', label: 'TIPO MOVIMIENTO' },
        { name: 'date_from', label: 'FECHA INICIO' },
        { name: 'date_until', label: 'FECHA FIN' },
        { name: 'registration_date', label: 'FECHA DE REGISTRO' },
    ];

    useEffect(()=> {
        getWorkers()
    },[]);

    useEffect(()=> {
        if(workerSelected){
            getMovementsByEmployee(workerSelected.id);
        }
    },[workerSelected]);

    const getWorkers = async() => {
        setLoading(true);
        const resp:any = await WorkerService.getWorkers();
        setWorkers(resp.data || []);
        setLoading(false);
    }

    const getMovementsByEmployee = async(idEmployee) => {
        setLoading(true);
        await MovementsService.getMovementsByEmployee(idEmployee).then((data) => {
            setMovements(data.data || []);
            setLoading(false);
        })
    }

    function RecuperarData(value){
        console.log(value);
        !workerSelected && setWorkerSelected(value);
        workerSelected && setMovemntSelected(value);
        setShowMovements(true);
        setView('movements');
        // setOpenModal(true)
    }

    return (
        <Protected>
            {loading && <Loading/>}
            <Container>
            <Breadcrumbs aria-label="breadcrumb">
                <StyledBreadcrumb
                    label="Lista de Empleados"
                    onClick={() => {
                        setView('workers');
                        setWorkerSelected('');
                        setShowMovements(false);
                    }}
                    icon={<GroupsIcon fontSize="small" />}
                />
                {
                    showMovemnts && (
                        <StyledBreadcrumb
                            label={`Movimientos`}
                            onClick={() => {setView('movements')}}
                            icon={<GroupsIcon fontSize="small" />}
                        />
                    )
                }
            </Breadcrumbs>
            {
                view == 'workers' && (
                    <TableDataV2
                        title={'Movimientos por empleado'}
                        data={workers}
                        header={cabecera}
                        actionSelect={setActionSelected}
                        status_action
                        disabled_title={false}
                        btn_disabled
                        btn_edit_disable={true}
                        btn_delete_disable={true}
                        btn_helper
                        currentView={view}
                        RecuperarData={RecuperarData}
                        />
                )
            }
            {
                view == 'movements' && (
                    <TableDataV2
                        title={`Movimientos de "${workerSelected?.name}"`}
                        data={movements}
                        header={cabeceraMovements}
                        actionSelect={setActionSelected}
                        setModalSave={setShowMovementsModal}
                        setModalDelete={setShowMovementsDeleteModal}
                        status_action
                        disabled_title={false}
                        btn_disabled={false}
                        btn_edit_disable
                        btn_delete_disable={false}
                        // btn_detail
                        currentView={view}
                        RecuperarData={RecuperarData}
                    />
                )
            }
            </Container>

            { 
                showMovementsModal && (
                    <ModalMovements
                        open={showMovementsModal}
                        closeModal={()=>{setShowMovementsModal(false)}}
                        actionSelected={actionSelected}
                        onListMovements={getMovementsByEmployee}
                        movement={movemntSelected}
                        workerSelected={workerSelected}
                        clearState={()=>{setMovemntSelected('')}}
                    />
                )
            }
            {
                actionSelected === 'delete' && (
                    <ModalMovementDelete
                        open={showMovementsDeleteModal}
                        closeModal={()=>{setShowMovementsDeleteModal(false)}}
                        actionSelected={actionSelected}
                        onListMovements={getMovementsByEmployee}
                        movement={movemntSelected}
                        workerSelected={workerSelected}
                        clearState={()=>{setMovemntSelected('')}}
                    />
                )
            }
        
        </Protected>
    )
};